import axios from 'axios'
import ConfigAPI from '@/config/api'
import Session from '@/handler/session'

var instance = axios.create()

export default {
  obtenerMiCalendario() {
    return instance.get(ConfigAPI.baseURL + 'staff/calendar' + Session.getToken(), {
      params: { _: Date.now() },
    })
  },
  actualizarMiCalendario() {
    return instance.post(ConfigAPI.baseURL + 'staff/calendar/refresh' + Session.getToken())
  },
  guardarMiCalendario(data) {
    return instance.post(ConfigAPI.baseURL + 'staff/calendar' + Session.getToken(), data)
  },
}
